var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "27px",
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01---Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01---Home-",
    transform: "translate(-1330.000000, -83.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1330.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.935483871,
    x2: 28.6258065,
    y2: 0.935483871,
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12.816129,
    x2: 28.6258065,
    y2: 12.816129,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 24.6967742,
    x2: 28.6258065,
    y2: 24.6967742,
    id: "Stroke-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtMenu);
export default __webpack_public_path__ + "static/media/bt-menu.676b885c369dd4f619099e316a125e4f.svg";
export { ForwardRef as ReactComponent };